import { FC, useEffect, useState } from "react";
import StepInfo from "pages/StepPages/components";
import JoinCommission from "./JoinCommission";
import { Button } from "components/shared";
import { ReactComponent as NoCommissionsSvg } from "images/listCommissions.svg";
import { ReactComponent as PlusSvg } from "images/PlusIcon.svg";
import { CommissionsInterface } from "./interfaces/commissions.interface";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getRoles } from "toolkit/steps/stepOne/stepOne.thunks";
import { useParams } from "react-router-dom";
import styles from "./StepOne.module.sass";
import { Link } from "react-router-dom";

const StepOne: FC = () => {
	const dispatch = useAppDispatch();

	const { organizationId } = useParams();

	const selectedOrganization = useAppSelector((state) => state.organizations.selectedOrganization);

	const [commissions, setCommissions] = useState<CommissionsInterface>({
		modalVisible: false,
		existingCommissions: [],
	});

	useEffect(() => {
		// $api.get(`/commissions/${organizationId}/list`).then((data) =>
		//   setCommissions((prevState) => ({
		//     ...prevState,
		//     existingCommissions: data.data.filter(
		//       (commission: any) => !commission.endDate
		//     ),
		//   }))
		// );

		dispatch(getRoles());
		//eslint-disable-next-line
	}, []);

	const toggleModal = (visible: boolean) => {
		setCommissions((prevState) => ({ ...prevState, modalVisible: visible }));
	};

	return (
		<div className="step-wrapper">
			<div className="step-header">
				<StepInfo
					stepTitle="1.Создание комиссии по категорированию ОКИИ"
					info="Создание комиссии по категорированию объектов КИИ"
					companyName={selectedOrganization?.fullName}
				/>
			</div>

			<div className={styles.main}>
				<NoCommissionsSvg />

				<h3 className={styles.title}>В данной организации пока нет комиссии</h3>
				<Link to={`/newCommission/${organizationId}`} replace>
					<Button className={styles.button}>
						<PlusSvg className={styles.plusIcon} />
						Создать комиссию
					</Button>
				</Link>
				{/* {selectedOrganization?.parent && (
          <Button
            className={styles.button}
            variant={BUTTON_VARIANTS.OUTLINED}
            onClick={() => toggleModal(true)}
            disabled={!commissions.existingCommissions.length}
          >
            Подключиться к существующей комиссии
          </Button>
        )} */}

				{commissions.modalVisible && (
					<JoinCommission
						handleClose={() => toggleModal(false)}
						existingCommissions={commissions.existingCommissions}
					/>
				)}
			</div>
		</div>
	);
};

export default StepOne;
